<template>
  <div class="filter-card-wrap" v-if="copyInstance.length !== 0">
    <div class="title-1">
      <my-icon class="icon-1" :type="iconType"></my-icon>
      <span>{{labelType}}</span>
    </div>
    <div class="title" v-for="item in copyInstance" :key="item.key">
      <div>
        <span>{{item.label}}</span>
        <my-icon class="my-icon" type="icon-close" @click="clearChecked(item.label, 'clearAll')"></my-icon>
      </div>
      <div v-for="i in item.values" :key="i">
        <span>{{i}}</span>
        <my-icon class="my-icon" type="icon-close" @click="clearChecked(i, 'clearItem', item.label)"></my-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    type: String // filter or exclude
  },
  data() {
    return {
      copyInstance: [],
      iconType: '',
      labelType: ''
    }
  },
  watch: {
    getFilterSelected: { // 监听筛选已选
      handler(nVal) {
        if (this.type === 'filter') {
          this.iconType = 'icon-viewlarger'
          this.labelType = '已选项'
          this.handlerChange(nVal)
        }
      },
      deep: true,
      immediate: true
    },
    getExcludeSelected: { // 监听排除已选
      handler(nVal) {
        if (this.type === 'exclude') {
          this.iconType = 'icon-reeor-fill'
          this.labelType = '已排除'
          this.handlerChange(nVal)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapGetters('filterGroup', [
      'getFilterSelected',
      'getExcludeSelected'
    ])
  },
  methods: {
    ...mapMutations('filterGroup', [
      'clearFilterOrExcludeSelected'
    ]),
    handlerChange(nVal) {
      this.copyInstance = Object.keys(nVal).reduce((pre, cur) => {
        const instance = nVal[cur]
        const {
          selectedValue, isCustomDeal, customValue, label
        } = instance
        const values = isCustomDeal
          ? customValue.map((item) => item.replace(label, ''))
          : selectedValue.map((item) => item.replace(/[\\"]/g, ''))
        pre.push({ ...instance, values })
        return pre
      }, [])
    },
    clearChecked(label, type, parent) {
      const target = this.type === 'filter' ? 'filterSelected' : 'excludeSelected'
      this.clearFilterOrExcludeSelected({
        target, label, type, parent
      })
      this.$emit('clearCardItem')
    }
  }
}
</script>
